import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Spin } from "antd";
import { Helmet } from "react-helmet";
import ProtectedLayout from "./layouts/protectedLayout";
import PublicLayout from "./layouts/publicLayout";
import TenantSetupLayout from "./layouts/tenantSetupLayout";
import Login from "./pages/login/login.container";
import Signup from "./pages/signup/signup.container";
import Verify from "./pages/verify/verify.container";
import UserRegistration from "./pages/userRegistration/userRegistration.container";
import ServerErrorPage from "./pages/serverErrorPage/serverErrorPage.container";
import NotFoundPage from "./pages/notFoundPage/notFoundPage.container";
import LandingPage from "./pages/landingPage/landingPage.container";
import Dashboard from "./pages/dashboard/dashboard.container";
import Channels from "./pages/channels/channels.container";
import ManageAgents from "./pages/manageAgents/manageAgents.container";
import Setup from "./pages/setup/setup.container";
import PlayGround from "./pages/playground/playground.container";
import EditDoc from "./pages/editdoc/EditDoc.container";
import KnowledgeBase from "./pages/kbSetup/kbSetup.container";
import FileManager from "./pages/FileManager/FileManager.container";
import ResolveConflict from "./pages/resolveConflict/resolveConflict.container";
import FeedbackLog from "./pages/feedbackLog/feedbackLog.container";
import Product from "./pages/product/product.container";
import ProductHierarchy from "./pages/product/ProductHierarchy";
import Prompt from "./pages/prompt_edit/prompt.container";
import Cta from "./pages/cta/cta.container";
import Settings from "./pages/settings/Settings.Container";
import Faq from "./pages/faq/faq.container";
import TenantSetup from "./pages/tenantSetup/tenantSetup.container";
import "./styles/app.scss";
import "./App.less";
import Sample from "./pages/Sample";
import { getAuthCookieValue } from "./utils/authCookie";
import { getTenantFromHostname } from "./utils/tenantFromHost";

function App() {
  const normalizedTenantName = (() => {
    const storedTenantName =
      getAuthCookieValue("tenant_label") || getAuthCookieValue("slug");
    const tenantFromStorage =
      typeof storedTenantName === "string" ? storedTenantName.trim() : "";
    if (tenantFromStorage) return tenantFromStorage;

    if (typeof window !== "undefined" && window.location) {
      const hostnameTenant = getTenantFromHostname(window.location.hostname);
      if (typeof hostnameTenant === "string" && hostnameTenant.trim()) {
        return hostnameTenant.trim();
      }
    }

    return "EKO";
  })();

  return (
    <Suspense
      fallback={
        <div
          className="fallback-container"
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      }
    >
      {/* This is the spin loading that appears on top left side  */}
      <BrowserRouter>
        <Helmet titleTemplate={`%s | ${normalizedTenantName}`} />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>Landing Page</title>
                </Helmet>
                <ProtectedLayout>
                  <LandingPage />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/dashboard"
            element={
              <>
                <Helmet>
                  <title>Dashboard</title>
                </Helmet>
                <ProtectedLayout>
                  <Dashboard />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/login"
            element={
              <>
                <Helmet>
                  <title>Login</title>
                </Helmet>
                <PublicLayout>
                  <Login />
                </PublicLayout>
              </>
            }
          />
          <Route
            path="/signup"
            element={
              <>
                <Helmet>
                  <title>Signup</title>
                </Helmet>
                <PublicLayout>
                  <Signup />
                </PublicLayout>
              </>
            }
          />
          <Route
            path="/verify"
            element={
              <>
                <Helmet>
                  <title>Verify</title>
                </Helmet>
                <PublicLayout>
                  <Verify />
                </PublicLayout>
              </>
            }
          />
          <Route
            path="/channels"
            element={
              <>
                <Helmet>
                  <title>Channels</title>
                </Helmet>
                <ProtectedLayout>
                  <Channels />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/manage-agents"
            element={
              <>
                <Helmet>
                  <title>Manage Agents</title>
                </Helmet>
                <ProtectedLayout>
                  <ManageAgents />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/invitation"
            element={
              <>
                <Helmet>
                  <title>User Registration</title>
                </Helmet>
                <PublicLayout>
                  <UserRegistration />
                </PublicLayout>
              </>
            }
          />
          <Route
            path="/setup"
            element={
              <>
                <Helmet>
                  <title>Setup</title>
                </Helmet>
                <ProtectedLayout>
                  <Setup />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/tenant-setup"
            element={
              <>
                <Helmet>
                  <title>Tenant Setup</title>
                </Helmet>
                <TenantSetupLayout>
                  <TenantSetup />
                </TenantSetupLayout>
              </>
            }
          />
          <Route
            path="/playground"
            element={
              <>
                <Helmet>
                  <title>Playground</title>
                </Helmet>
                <ProtectedLayout>
                  <PlayGround />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/editdoc"
            element={
              <>
                <Helmet>
                  <title>EditDoc</title>
                </Helmet>
                <ProtectedLayout>
                  <EditDoc />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/knowledge-base"
            element={
              <>
                <Helmet>
                  <title>KnowledgeBase</title>
                </Helmet>
                <ProtectedLayout>
                  <KnowledgeBase />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/file-manager"
            element={
              <>
                <Helmet>
                  <title>file_manager</title>
                </Helmet>
                <ProtectedLayout>
                  <FileManager />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/resolve-conflict"
            element={
              <>
                <Helmet>
                  <title>Resolve Confict</title>
                </Helmet>
                <ProtectedLayout>
                  <ResolveConflict />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/feedback-log"
            element={
              <>
                <Helmet>
                  <title>Feedback Log</title>
                </Helmet>
                <ProtectedLayout>
                  <FeedbackLog />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/products"
            element={
              <>
                <Helmet>
                  <title>Products</title>
                </Helmet>
                <ProtectedLayout>
                  <Product />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/product-hierarchy"
            element={
              <>
                <Helmet>
                  <title>Product Hierarchy</title>
                </Helmet>
                <ProtectedLayout>
                  <ProductHierarchy />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/prompt"
            element={
              <>
                <Helmet>
                  <title>prompt</title>
                </Helmet>
                <ProtectedLayout>
                  <Prompt />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/cta"
            element={
              <>
                <Helmet>
                  <title>CTA</title>
                </Helmet>
                <ProtectedLayout>
                  <Cta />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/settings"
            element={
              <>
                <Helmet>
                  <title>Settings</title>
                </Helmet>
                <ProtectedLayout>
                  <Settings />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/faq"
            element={
              <>
                <Helmet>
                  <title>FAQ</title>
                </Helmet>
                <ProtectedLayout>
                  <Faq />
                </ProtectedLayout>
              </>
            }
          />
          <Route
            path="/server-error"
            element={
              <>
                <Helmet>
                  <title>Server Error</title>
                </Helmet>
                <PublicLayout>
                  <ServerErrorPage />
                </PublicLayout>
              </>
            }
          />
          <Route
            path="/sample"
            element={
              <>
                <Helmet>
                  <title>Sample</title>
                </Helmet>
                <PublicLayout>
                  <Sample />
                </PublicLayout>
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                <Helmet>
                  <title>Page Not Found</title>
                </Helmet>
                <PublicLayout>
                  <NotFoundPage />
                </PublicLayout>
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
